import { render, staticRenderFns } from "./ChickDepurationDetailsModal.vue?vue&type=template&id=dc41b50c&scoped=true"
import script from "./ChickDepurationDetailsModal.vue?vue&type=script&lang=js"
export * from "./ChickDepurationDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc41b50c",
  null
  
)

export default component.exports